import { LegalLayout } from '../components/LegalLayout';

export const PrivacyPractices = () => {
    return (
        <LegalLayout title="Notice of Privacy Practices" lastUpdated="December 28, 2025">
            <p className="intro-text">
                THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION. PLEASE REVIEW IT CAREFULLY.
            </p>

            <section>
                <h2>1. Our Duty to Safeguard Your PHI</h2>
                <p>
                    We are committed to maintaining the privacy of your Protected Health Information ("PHI"). PHI includes information that can identify you and relates to your past, present, or future physical or mental health or condition, the provision of health care to you, or payment for your health care.
                </p>
                <p>
                    We are required by law to provide you with this Notice of our legal duties and privacy practices with respect to your PHI. We must follow the terms of the Notice that is currently in effect.
                </p>
            </section>

            <section>
                <h2>2. How We May Use and Disclose Your PHI</h2>
                <p>We may use and disclose your PHI for the following purposes:</p>
                <ul>
                    <li><strong>Treatment and Wellness Operations:</strong> We may use your PHI to generate your wellness protocols, analyze your biomarkers, and coordinate with our partner laboratories.</li>
                    <li><strong>Payment:</strong> We may use your PHI to process payments for our services.</li>
                    <li><strong>Healthcare Operations:</strong> We may use your PHI for our internal operations, such as quality assessment, improvement activities, and customer service.</li>
                    <li><strong>Business Associates:</strong> We may disclose PHI to third-party business associates who perform services on our behalf, provided they agree to safeguard your information.</li>
                    <li><strong>Required by Law:</strong> We will disclose PHI when required to do so by federal, state, or local law.</li>
                </ul>
            </section>

            <section>
                <h2>3. Your Rights Regarding Your PHI</h2>
                <p>You have the following rights regarding the PHI we maintain about you:</p>
                <ul>
                    <li><strong>Right to Inspect and Copy:</strong> You have the right to inspect and obtain a copy of your health records.</li>
                    <li><strong>Right to Request Restrictions:</strong> You have the right to request a restriction on certain uses and disclosures of your PHI.</li>
                    <li><strong>Right to Request Confidential Communications:</strong> You have the right to request that we communicate with you about health matters in a certain way or at a certain location.</li>
                    <li><strong>Right to Amend:</strong> If you feel that the PHI we have is incorrect or incomplete, you may ask us to amend it.</li>
                    <li><strong>Right to a Paper Copy of This Notice:</strong> You have the right to a paper copy of this notice upon request.</li>
                </ul>
            </section>

            <section>
                <h2>4. Changes to This Notice</h2>
                <p>
                    We reserve the right to change the terms of this Notice at any time. The new Notice will be effective for all PHI that we maintain, including PHI we created or received before we made the changes.
                </p>
            </section>

            <section>
                <h2>5. Complaints</h2>
                <p>
                    If you believe your privacy rights have been violated, you may file a complaint with us or with the Secretary of the Department of Health and Human Services. You will not be penalized for filing a complaint.
                </p>
                <p>
                    To file a complaint with us, please contact our Privacy Officer at contact@nostaviahealth.com.
                </p>
            </section>
        </LegalLayout>
    );
};
